var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-wrapper"},[_c('div',{ref:"itemsView",staticClass:"items-view"},[(_vm.isContainerValid(_vm.activeSubCategory.fields.component))?_c(_vm.activeSubCategory.fields.component + 'Container',{tag:"component",attrs:{"sub-category":_vm.activeSubCategory}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }